import { Row } from 'components/Layout';
import { useHistory } from 'react-router-dom';
import { LP_PROFILE } from 'adminConstants/routes';
import { Box, Typography, IconButton, Avatar, styled } from '@mui/material';
import { Settings } from '@mui/icons-material';

const UserAvatar = styled(Avatar)({
  width: '32px',
  height: '32px',
});

const rolesMap: Record<string, string> = {
  'lp-fund-manager': 'Fund Manager',
};

type Props = {
  user?: {
    firstName: string;
    lastName: string;
    profilePic: string;
    roleSlug: string;
  };
};

const UserProfile: React.FC<Props> = ({ user }) => {
  const history = useHistory();

  if (!user) return null;

  const userName =
    user.firstName && user.lastName
      ? `${user.firstName} ${user.lastName}`
      : '-';

  const userRole = user.roleSlug ? rolesMap[user.roleSlug] ?? '' : '-';

  return (
    <Row centered justify="space-between" spacing="xs">
      <Row centered spacing="xs">
        <UserAvatar src={user.profilePic} />
        <Box>
          <Typography variant="h6">{userName}</Typography>
          <Typography variant="body2">{userRole}</Typography>
        </Box>
      </Row>
      <IconButton
        onClick={() => {
          history.push(LP_PROFILE);
        }}
      >
        <Settings fontSize="small" color="action" />
      </IconButton>
    </Row>
  );
};

export default UserProfile;
